import Worker from "@/worker?worker";

const worker = new Worker();
const _uniqueIds = [];
const _callbacks = [];

const uniqueId = () => {
	let id = Math.random().toString(16).substring(2);
	while (_uniqueIds.includes(id)) {
		id = uniqueId();
	}
	return id;
}

worker.onmessage = (e) => {
	if (_callbacks[e.data]) {
		_callbacks[e.data].apply();
	}
};

const WorkerTimer = {
	setTimeout(callback, delay) {
		const timerId = uniqueId();
		_uniqueIds.push(timerId);
		_callbacks[timerId] = callback;
		worker.postMessage({type: "setTimeout", timerId, delay});
		return timerId;
	},

	clearTimeout(timerId) {
		if (_uniqueIds.includes(timerId)) {
			worker.postMessage({type: "clearTimeout", timerId});
			_uniqueIds.splice(_uniqueIds.indexOf(timerId), 1);
			delete _callbacks[timerId];
		}
	},

	setInterval(callback, delay) {
		const timerId = uniqueId();
		_uniqueIds.push(timerId);
		_callbacks[timerId] = callback;
		worker.postMessage({type: "setInterval", timerId, delay});
		return timerId;
	},

	clearInterval(timerId) {
		if (_uniqueIds.includes(timerId)) {
			worker.postMessage({type: "clearInterval", timerId});
			_uniqueIds.splice(_uniqueIds.indexOf(timerId), 1);
			delete _callbacks[timerId];
		}
	},

	clearAll() {
		worker.postMessage({type: "clearAll"});
		_uniqueIds.length = 0;
		_callbacks.length = 0;
	}
}

export default WorkerTimer;